import React, { Suspense, lazy, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createLogClient } from "API/swesum";
import Box from "@mui/material/Box";
import Paper from "Components/UI/Paper";
import { CircularProgress, Tab, Tabs } from "@mui/material";
import ClientInvoices from "./ClientInvoices";
import { useClient } from "Context/Client";

const ClientEndcustomers = lazy(() => import("./ClientEndcustomers"));
const Logs = lazy(() => import("Components/Workflows/Logs/Logs"));
const Reports = lazy(() => import("./Reports"));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const [beenLoaded, setBeenLoaded] = useState(false);
  if (value === index && !beenLoaded) {
    setBeenLoaded(true);
  }
  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {beenLoaded ? (
        <Suspense fallback={<>Loading...</>}>
          <Box>{children}</Box>
        </Suspense>
      ) : null}
    </div>
  );
}

export default function ClientWorkflows({
  logs,
  users,
  selectedLogs,
  resetSelectedLogs,
}) {
  const { client } = useClient();
  const { clientID } = useParams();
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  // Kontexten behåller föregående klient tills hämtningen är klar
  const clientIsLoaded =
    client && (!clientID || String(client.Id) === String(clientID));

  useEffect(() => {
    if (selectedLogs) {
      resetSelectedLogs();
      setTabindex(5);
    }
  }, [selectedLogs]);

  return (
    <>
      <Paper sx={{ minHeight: "200px" }}>
        {clientIsLoaded ? (
          // Nyckeln tvingar remount så att flikarnas state inte följer med till nästa klient
          <React.Fragment key={client.Id}>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Reskontra" />
              <Tab label="Slutkunder" />
              <Tab label="Loggar" />
              <Tab label="Rapporter" />
            </Tabs>

            <TabPanel value={tabIndex} index={0} id="tabPanel0">
              <ClientInvoices client={client} />
            </TabPanel>

            <TabPanel value={tabIndex} index={1} id="tabPanel0">
              <ClientEndcustomers client={client} />
            </TabPanel>

            <TabPanel value={tabIndex} index={2} id="tabPanel0">
              <Logs
                entityID={client.Id}
                logs={logs}
                users={users}
                call={createLogClient}
                checkbox={false}
              />
            </TabPanel>

            <TabPanel value={tabIndex} index={3} id="tabPanel0">
              <Reports client={client} />
            </TabPanel>
          </React.Fragment>
        ) : (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Paper>
    </>
  );
}
